export const ShoppingAdd = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.9996 8V6C14.9996 4.34315 13.6565 3 11.9996 3C10.3428 3 8.99964 4.34315 8.99964 6V8M10.9996 21H5.66525C5.05237 21 4.58369 20.4537 4.67688 19.8479L6.36919 8.84794C6.44424 8.36011 6.86399 8 7.35756 8H16.6417C17.1353 8 17.555 8.36011 17.6301 8.84794L18.0969 11.8824M17.9996 16V19M17.9996 19V22M17.9996 19H14.9996M17.9996 19H20.9996"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ShoppingAdd
